import { motion } from 'motion/react';
import { memo, useMemo } from 'react';
import { Button } from '@music-vine/cadence/ui';
import { POPULAR_SEARCHES } from '@/features/GlobalSearch/constants';
import type { AssetType } from '@/features/GlobalSearch/types/index';
interface NoResultsFoundProps {
  activeAssetType: AssetType;
  onTryPopularSearch: (term: string) => void;
  searchTerm: string | undefined;
}
export const NoResultsFound = memo(({
  searchTerm,
  activeAssetType,
  onTryPopularSearch
}: NoResultsFoundProps) => {
  const popularSearches = useMemo(() => POPULAR_SEARCHES[activeAssetType] ?? POPULAR_SEARCHES.music, [activeAssetType]);
  const displayTerm = searchTerm ?? '';
  return <motion.div animate={{
    opacity: 1
  }} className="flex flex-col items-center justify-center px-4 py-8 text-center" initial={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }}>
        <div className="mb-6">
          <h3 className="mb-2 font-semibold text-base text-gray-950 dark:text-white">
            No results found for "{displayTerm}"
          </h3>
          <p className="mb-6 text-gray-700 text-sm dark:text-gray-500">
            Try searching for something else or check out these popular
            searches:
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2">
          {popularSearches.map((term, idx) => <motion.div animate={{
        opacity: 1,
        y: 0
      }} initial={{
        opacity: 0,
        y: 10
      }} key={`suggestion-${term}`} transition={{
        delay: Math.min(idx * 0.05, 0.25),
        duration: 0.3
      }}>
              <Button borderRadius="full" className="bg-gray-100 hover:bg-gray-200 dark:bg-gray-900 dark:hover:bg-gray-800" onClick={() => onTryPopularSearch(term)} size="sm" variant="light">
                {term}
              </Button>
            </motion.div>)}
        </div>
      </motion.div>;
});
NoResultsFound.displayName = 'NoResultsFound';